var swiper = new Swiper(".banner-slider", {
  slidesPerView: 1,
  infinite:true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 1.5
    },
    768: {
      slidesPerView: 2,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    },
    1024: {
      slidesPerView: 1,
    },
  },
});
var swiper = new Swiper(".uspSwiper", {
  slidesPerView: 1,
  infinite:true,
  loop: true,
  autoplay: {
    delay: 3000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 1.5
    },
    768: {
      slidesPerView: 2,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    },
    1024: {
      slidesPerView: 3,
    },
  },
});

var swiper = new Swiper(".popular-product-block", {
  slidesPerView: 1.5,
  spaceBetween: 40,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".next-button",
    prevEl: ".pre-button"
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    768: {
      slidesPerView: 2.7,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 3.5,
      spaceBetween: 40,
    },
  },
});

var swiper = new Swiper(".popular-product-second-block", {
  slidesPerView: 1.5,
  spaceBetween: 40,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".next-product-button",
    prevEl: ".pre-product-button"
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    768: {
      slidesPerView: 2.7,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 3.5,
      spaceBetween: 40,
    },
  },
});
